import { layoutOptions, Layout } from '../types/categorical-bar-chart.js';

/**
 * Returns true if layout is a valid Layout
 * @param layout - layout
 */
export const isValidLayout = (
  layout: 'horizontal' | 'vertical',
): layout is Layout => layoutOptions.includes(layout);
